import React, { useEffect } from 'react'
import "./cityWise.scss"
import "../PersonalLoanEmiCalc/personalLoan.scss"
import ApplyLoan from './ApplyLoan'
import DocumentsRequired from './Documents'
import FeaturesAndBenefits from './Features'
import Header from './Header'
import Nav from "./Nav"
import WhyStashfin from './WhyStashfin'
import LoanEmiCalculator from './LoanEmiCal'
import RelatedLinks from './RelatedLinks'
import CityWiseJsonData from './cityWise.json'
import { useDispatch } from 'react-redux'
import { cityDataAction } from './actions'
import { useParams } from 'react-router-dom'
import FAQs from './Faq'

const CityWiseInstantPersonalLoans = () => {

  const dispatch = useDispatch()
  const {city} = useParams()

  useEffect(() => {
    const jsonData = CityWiseJsonData?.data
    dispatch(cityDataAction({city,jsonData}))
  },[])
  
  return (
    <React.Fragment>
      <Header/>
      <Nav/>
      <WhyStashfin/>
      <FeaturesAndBenefits/>
      <DocumentsRequired/>
      <ApplyLoan/>
      <LoanEmiCalculator/>
      <FAQs/>
      <RelatedLinks/>
    </React.Fragment>
  )
}

export default CityWiseInstantPersonalLoans
